import axios from 'axios';
import Config from './Config';
import AccessToken from './AccessToken'
import Cookies from 'js-cookie'

const BASE_URL = Config();
const getWebsite = {}
// const token = AccessToken();
// let token = Cookies.get('access_token');

getWebsite.GetWebsite = (endpoint, accessToken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 
getWebsite.GetCmsDetails = (endpoint, accessToken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 
getWebsite.DeleteWebsite = (endpoint, accessToken, callback) => {
    axios({
        method: 'DELETE',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 
getWebsite.AddWebsite = (details, endpoint, accessToken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 
getWebsite.GetWebsiteDetails = (endpoint, accessToken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}
getWebsite.EditWebsite = (details, endpoint, accessToken, callback) => {
    axios({
        method: 'PUT',
        url: `${BASE_URL}${endpoint}`,
        data: details,
        headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 
getWebsite.GetTemplateList = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
} 
export default getWebsite;
